import { NewCalendar } from '@hqo/react-components-library/dist/icons';
import styled from 'styled-components';

export const CalendarIcon = styled(NewCalendar)`
  color: ${({ theme }) => theme.colors.fontColor};
`;
